<template>
    <a-tabs :default-active-key="0">
        <template v-for="(c,index) in categories">
            <a-tab-pane :key="c.categoryId" 
                        :tab="c.categoryName"
            >
                <template v-for="i in productsByCategoryId(c.categoryId)">
                    <a-button type="primary" :key="i.itemId" @click="handleItemClicked(i)" class="category-button">
                        {{ i.itemName }}
                    </a-button>
                </template>
            </a-tab-pane>
        </template>
    </a-tabs>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'
export default {

    computed : {
        // ...mapState({
        //    categories : state => state.products.categoriesFromProductsList,
        //    products : state => state.products.products,
        // }),
        // ...mapGetters({
        //     productsByCategoryId : 'products/productsByCategoryId'
        // }),
        ...mapState({
          
           products : state => state.phoneService.products,
        }),
        ...mapGetters({
            productsByCategoryId : 'phoneService/productsByCategoryId',
            categories : 'phoneService/categoriesFromProductsList',
        }),
    },

    methods : {
        ...mapMutations({
            //handleItemClicked : 'ordering/ADD_ITEM_TO_CART_STATE'
        }),

        handleItemClicked(e) {

            //
            //Add to cart
            //
            console.log(e)
            this.$store.commit('ordering/ADD_ITEM_TO_CART_STATE', e);

            //
            //Update estimated pickup time
            //
            let maxTime = this.$store.state.phoneService.orderManagerState.maxWaitingTime;
            let currentWaitingTime = this.$store.state.phoneService.orderManagerState.currentWaitingTime;
            this.$store.commit('ordering/UPDATE_ESTIMATED_TIME_STATE');
            this.$store.commit('ordering/UPDATE_ESTIMATED_PICKUP_TIME_STATE', {'minWaitingTime' : currentWaitingTime, 'maxWaitingTime' : maxTime });

        }
    }
}
</script>

<style>

</style>